export const PROCEDURES_EMAILS_ON_GET_ALL_REQUESTED = 'PROCEDURES_EMAILS_ON_GET_ALL_REQUESTED';
export const PROCEDURES_EMAILS_ON_GET_ALL_SUCCEEDED = 'PROCEDURES_EMAILS_ON_GET_ALL_SUCCEEDED';
export const PROCEDURES_EMAILS_ON_GET_ALL_FAILED = 'PROCEDURES_EMAILS_ON_GET_ALL_FAILED';

export const PROCEDURES_EMAILS_ON_RESEND_REQUESTED = 'PROCEDURES_EMAILS_ON_RESEND_REQUESTED';
export const PROCEDURES_EMAILS_ON_RESEND_SUCCEEDED = 'PROCEDURES_EMAILS_ON_RESEND_SUCCEEDED';
export const PROCEDURES_EMAILS_ON_RESEND_FAILED = 'PROCEDURES_EMAILS_ON_RESEND_FAILED';

export const PROCEDURES_EMAILS_ON_SEND_EMAILS_REQUESTED =
  'PROCEDURES_EMAILS_ON_SEND_EMAILS_REQUESTED';
export const PROCEDURES_EMAILS_ON_SEND_EMAILS_SUCCEEDED =
  'PROCEDURES_EMAILS_ON_SEND_EMAILS_SUCCEEDED';
export const PROCEDURES_EMAILS_ON_SEND_EMAILS_FAILED = 'PROCEDURES_EMAILS_ON_SEND_EMAILS_FAILED';
